(function () {
  document.querySelectorAll('[data-bdc-finder-options]').forEach(function (optionsWrap) {
    var section = optionsWrap.closest('.bdc-finder');
    if (!section) return;

    var options = Array.prototype.slice.call(optionsWrap.querySelectorAll('[data-bdc-finder-option]'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('[data-bdc-finder-panel]'));

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        var targetId = option.getAttribute('data-target');

        options.forEach(function (o) {
          o.classList.remove('is-active');
          o.setAttribute('aria-selected', 'false');
        });
        option.classList.add('is-active');
        option.setAttribute('aria-selected', 'true');

        panels.forEach(function (panel) {
          panel.classList.toggle('is-active', panel.id === targetId);
        });
      });
    });
  });
})();